module.exports = __webpack_public_path__ + "assets/SMC.png";


//////////////////
// WEBPACK FOOTER
// ./libs/images/SMC.png
// module id = 346
// module chunks = 0